import { render, staticRenderFns } from "./thirdPartyEdit.vue?vue&type=template&id=938460c2&scoped=true&"
import script from "./thirdPartyEdit.vue?vue&type=script&lang=js&"
export * from "./thirdPartyEdit.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyEdit.vue?vue&type=style&index=0&id=938460c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938460c2",
  null
  
)

export default component.exports